<script lang="ts">
    import Alert from './alert.svelte';
    import LandscapeMode from '@src/components/ui/notifications/landscape-mode.svelte';
    export let notifications = [];
</script>

<LandscapeMode />

{#each notifications as notification (notification.index)}
    <Alert {...notification} on:close={notification.close} key={notification.index} type={notification?.type} />
{/each}
